import {computed, ComputedRef, Ref, ref} from "vue"
import {AfterFetchContext, MaybeRefOrGetter, useFetch, UseFetchOptions, UseFetchReturn} from "@vueuse/core"

export const useFetcher = useFetch // soft-deprecated: use one of the functions below instead

// Equivalent to useFetch but immediate is false by default.  Other options or changed defaults may come later.
// client code should primarily use this.  It doesn't use the MSW workaround, but tests should just mock the client.
export function useEndpoint(endpoint: MaybeRefOrGetter<string>, options: UseFetchOptions = {}) {
  const defaults: UseFetchOptions = {immediate: false}
  return useFetch(endpoint, {...defaults, ...options})
}

// Good for one-offs, but provides no access to the fetcher if other information like loading/status/error is needed
export function useGetJson<T>(
  endpoint: MaybeRefOrGetter<string>,
  options: UseFetchOptions = {},
): ComputedRef<T | undefined> {
  return useGetJsonWithFetcher<T>(endpoint, options).data
}

// Provides a computed .data member in the return that works around an issue in testing environments.
export function useGetJsonWithFetcher<T>(
  endpoint: MaybeRefOrGetter<string>,
  options: UseFetchOptions = {},
): {data: ComputedRef<T | undefined>; fetcher: UseFetchReturn<T>} {
  const out: Ref<T | undefined> = ref(undefined)

  // useFetch unfortunately doesn't get along with MSW, at least not with the Vue 2.x libraries we're using.
  // fetcher.data is never updated, but the afterFetch callback does run, so we use that instead.
  // noinspection JSUnusedGlobalSymbols (afterFetch is in fact used, dummy)
  const opts = {
    afterFetch: (ctx: AfterFetchContext) => out.value = ctx.data,
    ...options,
  }

  const fetcher = useFetch(endpoint, opts).json()
  return {data: computed(() => out.value), fetcher}
}

// CSRF stuff below -- keep til we get CSRF on json routes fully sorted.

// I'm fairly sure this is doing nothing.  At least it _should_ be doing nothing since CSRF isn't a thing with JSON.
//
// export const CSRF_TOKEN = ref("") // a mutable global variable?  sure, why not.
// export const useFetcher = createFetch({
//   options: {
//     beforeFetch({options}: BeforeFetchContext) {
//       options.headers["X-CSRF-TOKEN"] = CSRF_TOKEN.value
//       return {options}
//     },
//   },
// })
